import React from 'react'
import PropTypes from 'prop-types'
import withStyles from '@material-ui/core/styles/withStyles'
import IconButton from '@material-ui/core/IconButton'
import Icon from '@material-ui/core/Icon'
import Tooltip from '@material-ui/core/Tooltip'

const styles = theme => ({
  Help: {
    display: 'inline-block',
    verticalAlign: 'bottom'
  },
  iconButtonRoot: {
    fontSize: 'inherit',
    padding: '0.3em',
    verticalAlign: 'text-top'
  },
  iconButtonLabel: {
    fontSize: 'inherit'
  },
  iconRoot: {
    fontSize: 'inherit'
  }
})

const HelpButton = props => {
  const { classes, proxy } = props
  const { onClickIconButton } = proxy
  return (
    <IconButton
      classes={{
        root: classes.iconButtonRoot,
        label: classes.iconButtonLabel
      }}
      onClick={onClickIconButton}
    >
      <Icon classes={{ root: classes.iconRoot }}>help</Icon>
    </IconButton>
  )
}

const Help = props => {
  const { classes, proxy, ...others } = props
  const { description = {} } = others
  const { tooltip } = description
  return (
    <div className={classes.Help}>
      {tooltip ? (
        <Tooltip title={tooltip} placement="top">
          <HelpButton {...props} />
        </Tooltip>
      ) : (
        <HelpButton {...props} />
      )}
    </div>
  )
}
Help.defaultProps = {}
Help.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(Help)
